import { render, staticRenderFns } from "./salgpm.vue?vue&type=template&id=3317e5d6&scoped=true&"
import script from "./salgpm.vue?vue&type=script&lang=js&"
export * from "./salgpm.vue?vue&type=script&lang=js&"
import style0 from "./salgpm.vue?vue&type=style&index=0&id=3317e5d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3317e5d6",
  null
  
)

export default component.exports